require('./myTextTruncator.scss');

class MyTextTruncator {}

module.exports = MyTextTruncator;
